const bannerSwiperEls = document.querySelectorAll(".collection-banner.mySwiper");

bannerSwiperEls.forEach((bannerSwiperEl) => {
  const slideCount = bannerSwiperEl.querySelectorAll(".swiper-slide").length;

  if (!slideCount) {
    return;
  }

  new Swiper(bannerSwiperEl, {
    loop: slideCount > 1,
    navigation: {
      nextEl: bannerSwiperEl.querySelector(".swiper-button-next"),
      prevEl: bannerSwiperEl.querySelector(".swiper-button-prev"),
    },
    slidesPerView: 1,
    pagination: {
      el: bannerSwiperEl.querySelector(".swiper-pagination"),
      clickable: true,
    },
    autoplay:
      slideCount > 1
        ? {
            delay: 6000,
            disableOnInteraction: false,
          }
        : false,
    spaceBetween: 8,
  });
});
